export enum BUSINESS_OBJECT_VERSION {
  PRO = 'PRO',
  LITE = 'LITE',
  LITE_PLUS = 'LITE_PLUS',
}
